import React from 'react';
function VerticalDivider(_ref) {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: color,
    x: "11",
    y: "2",
    width: "2",
    height: "20",
    rx: "1"
  }));
}
export default /*#__PURE__*/React.memo(VerticalDivider);